"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformEntityListApiResponse = void 0;
const api_response_1 = require("./api.response");
class TransformEntityListApiResponse extends api_response_1.TransformApiResponse {
    response;
    constructor(response) {
        super();
        this.response = response;
    }
    handle({ response = this.response, attributes, relations, schema, }) {
        const data = {
            page: response.page,
            per_page: response.per_page,
            page_count: response.page_count,
            data: response.data.map((item) => {
                // Attributes
                const dataAttributes = this.transformAttributes({
                    attributes: item.attributes,
                    transform: attributes,
                });
                // Relations
                const dataRelations = this.transformApiEntityRelations({
                    relationships: item.relationships,
                    included: response.included,
                    transform: relations,
                });
                return {
                    id: item.id,
                    ...dataAttributes,
                    ...dataRelations,
                };
            }),
        };
        try {
            return (schema ? schema.parse(data) : data);
        }
        catch (err) {
            console.error('TransformEntityListApiResponse::', {
                response,
                transform: data,
            });
            throw err;
        }
    }
}
exports.TransformEntityListApiResponse = TransformEntityListApiResponse;
